import React from 'react';
import styles from '../../search.scss';
import SearchLocation from './SearchLocation';
import DistanceFilter from './DistanceFilter';

const LocationFilterComponent = props => {
    const { clearFilters, value, geoLocation, handleLocationChange, handleLocationSelect, handleCurrentLocationClick, distance, handleDistanceChange, 'data-testid': dataTestId } = props;

    return (
        <React.Fragment>
            <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.location-title`}>Location<span className={`d-none d-md-block link underline float-right`} onClick={() => clearFilters('location', true)} data-testid={dataTestId && `${dataTestId}.location-clear-link`}>clear</span></div>
            <div className="row">
                <div className="col">
                    <SearchLocation
                        className={`form-control ${styles.locationSearchInput}`}
                        value={value}
                        geoLocation={geoLocation}
                        onChange={(location) => handleLocationChange(location)}
                        handleClearClick={(cb) => {
                            handleLocationChange('');
                            if (cb) {
                                cb();
                            }
                        }}
                        onSelect={(location, placeId) => handleLocationSelect(location, placeId)}
                        onCurrentLocationClick={handleCurrentLocationClick}
                        data-testid={dataTestId && `${dataTestId}.search-input`}
                    />
                </div>
            </div>
            {!props.value && (
                <div className="row">
                    <div className="col mt16">
                        <div className={`link underline ml8 fs14`} onClick={handleCurrentLocationClick} data-testid={dataTestId && `${dataTestId}.current-location-btn`}><i className="uts uts-location" /> Current Location</div>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col mt24">
                    <DistanceFilter
                        distance={distance}
                        handleDistanceChange={handleDistanceChange}
                        data-testid={dataTestId && `${dataTestId}.distance-filter`}
                    />
                </div>
            </div>
            {/* filterType && (filterType == 'players' || filterType == 'events' || filterType == 'clubs' || filterType == 'colleges' || filterType == 'highSchools') && (
                <React.Fragment>
                    {userLoggedIn && (
                        <React.Fragment>
                            <div className={styles.searchFilterModalTitle}>Location by country and region</div>
                            {isPowerUser ? (
                                <React.Fragment>
                                    <div className={styles.searchFilterModalBody}>
                                        <div className="row">
                                            <div className="col">
                                                <select
                                                    className="form-control"
                                                    value={locationCountryName}
                                                    onChange={handleLocationCountryNameChange}
                                                >
                                                    <option value="">Select a country</option>
                                                    {locationCountryNameList && locationCountryNameList.map(option => <option value={option.value} key={option.value}>{option.label}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {locationStateNameList && locationStateNameList.length > 0 && (
                                        <div className={styles.searchFilterModalBody}>
                                            <div className="row">
                                                <div className="col">
                                                    <select
                                                        className="form-control"
                                                        value={locationStateName}
                                                        onChange={handleLocationStateNameChange}
                                                    >
                                                        <option value="">All states/regions</option>
                                                        {locationStateNameList && locationStateNameList.map(option => <option value={option.value} key={option.value}>{option.label}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : (
                                <div className={styles.searchFilterModalBody}>
                                    <div className="row">
                                        <div className="col">
                                            <p><u className="clickable text-teal" onClick={() => handleUpgradeToPowerClick()}>Upgrade to Power</u> to search by country and state/region.</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </React.Fragment>
            ) */}
        </React.Fragment>
    );
};

export default LocationFilterComponent;
